import { Box, IconButton, Table, TableBody, TableHead, TableRow } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  LabelContent,
  HeadTableCell,
  RowTableCell,
} from '../../../common';
import { formatDate } from '../utils/updateDebtUtils';

const UpdateDebtDetailsDialog = ({ open, onClose, selectedItem }) => {
  const handlePrint = () => {
    const originalSize = document.body.style.zoom;
    document.body.style.zoom = '70%';
    window.print();
    document.body.style.zoom = originalSize;
  };

  if (!selectedItem) return null;

  return (
    <DialogContainer 
      open={open} 
      onClose={onClose} 
      size="large"
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '90vh',
          overflow: 'auto',
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          CUPONES ADEUDADOS
          <IconButton onClick={handlePrint}>
            <PrintIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogBody>
        {/* Información del contrato */}
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <LabelContent 
            label="ORDEN NÚMERO" 
            content={selectedItem.header?.contract_number} 
            labelColor="primary.main" 
          />
          <LabelContent 
            label="SUSCRIPTOR" 
            content={selectedItem.header?.subscriber} 
            labelColor="primary.main" 
          />
        </Box>

        {/* Tabla de cupones */}
        <Box sx={{ 
          overflow: 'auto',
          maxWidth: '100%',
          border: '1px solid #e0e0e0',
          borderRadius: 1,
        }}>
          <Table aria-label="debt details table">
            <TableHead>
              <TableRow>
                <HeadTableCell>Numero Cuota</HeadTableCell>
                <HeadTableCell>Fecha 1er Venc.</HeadTableCell>
                <HeadTableCell>Importe 1er</HeadTableCell>
                <HeadTableCell>Fecha 2do Venc.</HeadTableCell>
                <HeadTableCell>Importe 2do</HeadTableCell>
                <HeadTableCell>Fecha 3er Venc.</HeadTableCell>
                <HeadTableCell>Importe 3er</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedItem.coupons?.map((coupon, index) => (
                <TableRow key={index}>
                  <RowTableCell>
                    Cuota: {coupon.fee_number1}
                    {coupon.fee_number2 ? ` - ${coupon.fee_number2}` : ''}
                  </RowTableCell>
                  <RowTableCell>{formatDate(coupon.first_due_date)}</RowTableCell>
                  <RowTableCell>$ {coupon.first_due_amount}</RowTableCell>
                  <RowTableCell>{formatDate(coupon.second_due_date)}</RowTableCell>
                  <RowTableCell>$ {coupon.second_due_amount}</RowTableCell>
                  <RowTableCell>{formatDate(coupon.third_due_date)}</RowTableCell>
                  <RowTableCell>$ {coupon.third_due_amount}</RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>

        <Box sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mt: 2,
          mr: 2,
        }}>
          <LabelContent 
            label="Total" 
            content={`$${selectedItem.header?.total}`} 
            labelColor="primary.main"
            sx={{ fontSize: '18px', fontWeight: 'bold' }}
          />
        </Box>
      </DialogBody>
    </DialogContainer>
  );
};

export default UpdateDebtDetailsDialog;